import React from "react";
import styled from "styled-components";
import PageMargins from "../styled/PageMargins";

const Info = styled.div`
  text-transform: uppercase;
`;

export const ListingInfo = React.forwardRef(function ListingInfoFunction(
  {
    spaceBottom = 6,
    children,
    id,
    spaceMinHeight,
  }: {
    children: React.ReactNode;
    spaceBottom?: number;
    spaceMinHeight?: number;
    id?: string;
  },
  ref
) {
  return (
    <PageMargins spaceTop={9} spaceBottom={spaceBottom} id={id} ref={ref as any} spaceMinHeight={spaceMinHeight}>
      <Info>{children}</Info>
    </PageMargins>
  );
});
